var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-block"},[_c('i',{staticClass:"back-btn el-icon-back",attrs:{"title":"返回"},on:{"click":_vm.goBack}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }